//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { find } from 'lodash'
import { OpKind } from '@taquito/taquito'

export default {
  name: 'PurchaseTokenDialog',
  props: {
    project: {
      type: Object,
      default: null,
    },
    token: {
      type: Object,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
    purchased: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      dialog: false,
      agree: false,
      confirmation: false,
      loading: false,
      referredBy: null,
      referredByAlias: null,
    }
  },
  computed: {
    ask() {
      const ask = find(this.token.Trades, (t) => t.trade_type === 'ask')
      if (ask) return ask
      return null
    },
    askPrice() {
      if (this.ask) {
        const price = this.ask.price / 1000000

        return Number.isInteger(price) ? price : price.toFixed(3)
      }
      return null
    },
    userAddress() {
      return this.$store.getters.userAddress
    },
  },
  watch: {
    dialog(v) {
      if (v === false && this.confirmation === true) {
        this.purchased(this.token)
      }
      if (v && this.confirmation === false) {
        this.confirmation = false
      }
    },
  },
  methods: {
    handleOpen() {
      this.dialog = true
    },
    openHelpWallet() {
      this.dialog = false
      this.$refs.helpWalletDialog.handleOpen()
    },
    async isValidReferredBy() {
      try {
        const { tzktPrefix } = this.$config
        const storageResp = await this.$axios(
          `https://api${tzktPrefix}.tzkt.io/v1/contracts/${this.project.referral_contract}/storage?path=referrals`
        )
        const bmId = storageResp?.data
        const resp = await this.$axios(
          `https://api${tzktPrefix}.tzkt.io/v1/bigmaps/${bmId}/keys/${this.referredBy}`
        )
        return resp && resp?.data
      } catch (err) {
        return false
      }
    },
    async buyToken() {
      try {
        this.confirmation = false
        this.loading = true

        this.referredBy = this.$cookies.get(`${this.project.slug}-ref`)

        const transactions = []
        // set referred by if this project supports affiliate marketing
        if (this.project.referral_contract) {
          // const match = this.referredBy.match(/[A-Za-z0-9_-]+/)
          if (
            !this.referredBy ||
            this.referredBy.length < 4 ||
            this.referredBy.length > 36
          ) {
            this.loading = false
            this.$store.dispatch('addSnackbar', {
              text: `Your invitation seems to be invalid. Please use a valid invitation to proceed.`,
              type: 'error',
            })
            return
          }
          // convert tez domains..
          const match = this.referredBy.match(/tz[A-Za-z0-9_-]{34}/)
          if (!match) {
            const addr = await this.$globals.resolveNameToAddress(
              this.referredBy
            )
            if (!addr) {
              this.loading = false
              this.$store.dispatch('addSnackbar', {
                text: `Your invitation seems to be invalid. Please use a valid invitation to proceed.`,
                type: 'error',
              })
              return
            }
            this.referredByAlias = this.referredBy
            this.referredBy = addr
          }
          const ref = await this.$globals.tezos.wallet.at(
            this.project.referral_contract
          )
          const isValid = await this.isValidReferredBy()
          if (!isValid) {
            this.loading = false
            this.$store.dispatch('addSnackbar', {
              text: `Your invitation seems to be invalid. Please use a valid invitation to proceed.`,
              type: 'error',
            })
            return
          }
          transactions.push({
            kind: OpKind.TRANSACTION,
            ...ref.methods.set_referred_by(this.referredBy).toTransferParams(),
          })
        }

        const opts = {}
        opts.amount = this.ask.price
        opts.mutez = true
        const market = await this.$globals.tezos.wallet.at(
          this.ask.market_address
        )
        transactions.push({
          kind: OpKind.TRANSACTION,
          ...market.methods
            .fulfill_ask(1, this.ask.trade_id)
            .toTransferParams(),
          ...opts,
        })
        const batch = await this.$globals.tezos.wallet.batch(transactions)
        const op = await batch.send()
        await op.confirmation(1)
        this.loading = false
        this.confirmation = true
        if (!this.dialog) {
          this.$store.dispatch('addSnackbar', {
            text: `You successfully purchased ${this.token.name} for ${this.askPrice} XTZ (Tezos).`,
          })
        }
        this.purchased(this.token)
      } catch (e) {
        this.loading = false
        console.error('Unable to purchase token', e)
        this.$store.dispatch('addSnackbar', {
          text: 'There was an error while trying to purchase. Please try again later. (You can try disconnecting and reconnecting your wallet.)',
          type: 'error',
        })
        if (e?.message && e?.message?.includes('ABORTED_ERROR')) {
          this.disconnectWallet()
        }
      }
    },
    async connectWallet() {
      this.loading = true

      try {
        const userAddress = await this.$globals.connectWallet()
        const userAlias = await this.$globals.resolveAddressToName(userAddress)
        this.$store.commit('INIT_USER_WALLET', {
          wallet: userAddress,
          alias: userAlias,
        })
        this.$store.dispatch('logTerms', {
          wallet: userAddress,
          version: this.$config.termsVersion,
        })
        this.$store.dispatch('loadBalance', userAddress)
        this.loading = false
      } catch (e) {
        console.error('Unable to connect wallet', e)
        this.loading = false
      }
    },
    async disconnectWallet() {
      await this.$globals.disconnectWallet()
      this.$store.commit('INIT_USER_WALLET', { wallet: null, alias: null })
    },
  },
}
